import { AppLink, PdfLink, UrlLink, WP_Service } from '../../../model/models';
import { ServicesServiceProps } from '../../../pages/ServicesPage';
import Affluences from '../../affluence/Affluences';
import Faq from '../../faq/Faq';
import Form from '../../forms/Forms';
import GForm from '../../gforms/GForm';
import HTMLContent from '../../globals/HTMLContent';
import { SanitizeHTML } from '../../globals/SanitizeHTML';
import { IconSize, ServiceIcon } from '../ServiceIcon';
import {
  AppLinkDiv,
  AppLinkIcon,
  AppLinkPdf,
  AppLinkTitle,
  AppLinkUrl,
  AppServiceLink,
  ServiceAppLink,
} from './subContent/AppLink';
import Discovery from './subContent/Discovery';
import ServiceBreadcrumb from './subContent/ServiceBreadcrumb';

export const ServiceContent: React.FC<ServicesServiceProps> = ({
  service,
  services,
}) => {
  const childs = services.filter((s) => s.parent === service.id);

  const isAffluences = (content: any) => {
    return content.includes('class="affluences') ? true : false;
  };

  const isDiscovery = (content: string) => {
    return content.includes('[discovery]') ? true : false;
  };

  const isDiscoverySet = isDiscovery(service.content.rendered);

  const content = isDiscovery(service.content.rendered)
    ? service.content.rendered.replace('[discovery]', '')
    : service.content.rendered;

  return (
    <>
      <img
        className="z-0 relative h-60 w-full object-cover bg-lightGrey md:rounded-3xl"
        src={service.acf.cover?.sizes?.large}
        alt=""
      />
      <div className="bg-white rounded-t-3xl -mt-9 z-10 relative pt-8 px-4 md:-mt-0 h-full md:h-auto overflow-hidden">
        <ServiceBreadcrumb service={service} services={services} />
        {service.acf.icon && (
          <ServiceIcon
            service={service}
            size={IconSize.large}
            className="mt-9 mx-auto"
          />
        )}
        <SanitizeHTML
          tag="h3"
          html={service.title.rendered}
          className="mt-6 text-black font-medium text-center text-2xl mb-2"
        />
        {service.acf.subtitle ? (
          <SanitizeHTML
            tag="h4"
            html={service.acf.subtitle}
            className="mt-2 text-gray text-center mb-2"
          />
        ) : (
          ''
        )}
        {isAffluences(content) ? (
          <Affluences content={content} />
        ) : (
          <div className="styled-content bg-white">
            <HTMLContent html={content} />
          </div>
        )}
        {isDiscoverySet && <Discovery />}
        <ul className="">
          {service.acf.links &&
            Object.values(service.acf.links).map((link: AppLink, index) => (
              <ServiceAppLink key={index}>
                {link.acf_fc_layout === 'pdf' && (
                  <AppLinkPdf link={link as PdfLink}>
                    <AppLinkDiv>
                      <AppLinkTitle>{link.name}</AppLinkTitle>
                      <AppLinkIcon link={link} />
                    </AppLinkDiv>
                  </AppLinkPdf>
                )}
                {link.acf_fc_layout === 'external_link' && (
                  <AppLinkUrl link={link as UrlLink}>
                    <AppLinkDiv>
                      <AppLinkTitle>{link.name}</AppLinkTitle>
                      <AppLinkIcon link={link} />
                    </AppLinkDiv>
                  </AppLinkUrl>
                )}
              </ServiceAppLink>
            ))}
        </ul>
        <ul className="">
          {childs.map((child: WP_Service, index: number) => (
            <ServiceAppLink key={index}>
              <AppServiceLink service={child}>
                <AppLinkDiv>
                  {/* <i className={child.acf.icon ? child.acf.icon : serviceI} aria-hidden="true"></i> */}
                  <AppLinkTitle>{child.title.rendered}</AppLinkTitle>
                  <ServiceIcon service={child} size={IconSize.medium} />
                </AppLinkDiv>
              </AppServiceLink>
            </ServiceAppLink>
          ))}
        </ul>
      </div>
      <Faq faq={service.acf.faq} />
      <Form postId={service.id} form={service.acf.form} />
      {service.acf.gform?.gform_activation === true &&
        service.acf.gform.gform && <GForm form={service.acf.gform.gform} />}
    </>
  );
};
export default ServiceContent;
